import React from 'react';
import { Link } from 'react-router-dom';
import catalogueStructure from '../data/catalogueStructure';
import { formatProductPrice } from '../utils/productPrice';

export const ProductCardGrid = ({ product }) => {
  const categoryName = catalogueStructure.find(c => c.slug === product.category)?.name || product.category;

  return (
    <div
      className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all group"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative aspect-[4/3] bg-gray-50">
        <img
          src={product.image}
          alt={`${product.name} – location ${categoryName} en Normandie`}
          className="w-full h-full object-contain p-2 transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {product.badge && (
          <span className="absolute top-3 right-3 px-3 py-1 bg-orange-500 text-white text-xs font-bold rounded-full">
            {product.badge}
          </span>
        )}
      </div>
      <div className="p-5">
        <span className="text-xs text-gray-400 uppercase tracking-wide">{categoryName}</span>
        <h3 className="text-base font-semibold text-gray-900 mt-1">{product.name}</h3>
        <p className="text-sm text-gray-500 mt-1 mb-3 line-clamp-3">{product.description}</p>
        <div className="flex items-center justify-between">
          <div>
            {formatProductPrice(product) && (
              <span className="text-lg font-bold text-orange-500">{formatProductPrice(product)}</span>
            )}
          </div>
          {product.booqableUrl ? (
            <a
              href={product.booqableUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-orange-500 text-white text-sm font-medium rounded-lg hover:bg-orange-600 transition-colors"
              data-testid={`reserve-btn-${product.id}`}
            >
              Réserver
            </a>
          ) : (
            <Link
              to="/devis"
              className="px-4 py-2 bg-orange-500 text-white text-sm font-medium rounded-lg hover:bg-orange-600 transition-colors"
              data-testid={`devis-btn-${product.id}`}
            >
              Réserver
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export const ProductCardList = ({ product }) => {
  const categoryName = catalogueStructure.find(c => c.slug === product.category)?.name || product.category;
  return (
    <div
      className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow flex flex-col sm:flex-row"
      data-testid={`product-list-${product.id}`}
    >
      <div className="sm:w-48 h-48 sm:h-auto flex-shrink-0 relative bg-gray-50">
        <img
          src={product.image}
          alt={`${product.name} – location ${categoryName} en Normandie`}
          className="w-full h-full object-contain p-2"
          loading="lazy"
        />
        {product.badge && (
          <span className="absolute top-2 left-2 px-2 py-1 bg-orange-500 text-white text-xs font-bold rounded-full">
            {product.badge}
          </span>
        )}
      </div>
      <div className="flex-1 p-5">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">{product.name}</h3>
            <p className="text-sm text-gray-500 mt-1 sm:pr-6">{product.description}</p>
          </div>
          <div className="mt-4 sm:mt-0 sm:text-right flex-shrink-0">
            {formatProductPrice(product) && (
              <span className="text-xl font-bold text-orange-500 block">{formatProductPrice(product)}</span>
            )}
            {product.booqableUrl ? (
              <a
                href={product.booqableUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 inline-flex items-center gap-2 px-4 py-2 bg-orange-500 text-white text-sm font-medium rounded-lg hover:bg-orange-600 transition-colors"
              >
                Réserver
              </a>
            ) : (
              <Link
                to="/devis"
                className="mt-2 inline-flex items-center gap-2 px-4 py-2 bg-orange-500 text-white text-sm font-medium rounded-lg hover:bg-orange-600 transition-colors"
              >
                Réserver
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
